<template>
  <div ref="paypalContainerRef" style="min-height: 1rem">
    <div v-if="pending" class="h-4 w-3/4 skeleton" />
  </div>
</template>

<script lang="ts" setup>
import type { PayPalMessagesComponentOptions, PayPalScriptOptions } from '@paypal/paypal-js'
import { loadScript } from '@paypal/paypal-js'

const { amount, placement } = defineProps<{
  amount: number
  placement: Exclude<PayPalMessagesComponentOptions['placement'], undefined>
}>()

const { configPayPal } = useFeatureFlags()
const { style, showAmount } = useAppConfig().components.paypal?.payments || {}
const buyerCountry = useCountryCode()
const pending = ref(true)

const PAYPAL_NAMESPACE = 'paypal-paylater'
const paypalContainerRef = templateRef('paypalContainerRef')

const loadPaypal = async () => {
  try {
    await nextTick()

    const paypalConfig: PayPalScriptOptions = {
      clientId: configPayPal?.clientId,
      components: ['messages'],
      dataNamespace: PAYPAL_NAMESPACE
    }

    const paypalInstance = window[PAYPAL_NAMESPACE] || await loadScript(paypalConfig)
      .catch((err) => {
        log.error(`failed to load the PayPal JS SDK script: ${err}`)
      })

    if (!paypalContainerRef.value) return

    paypalInstance?.Messages?.({
      ...(showAmount[placement] ? { amount } : {}),
      buyerCountry,
      placement,
      style
    } as PayPalMessagesComponentOptions).render(paypalContainerRef.value)

    pending.value = false
  }
  catch (error) {
    log.warn(`PayPal initialization error: ${error}`)
    pending.value = false
  }
}

watch(() => amount, (value) => {
  paypalContainerRef.value?.setAttribute('data-pp-amount', value.toString())
})

onMounted(() => loadPaypal())
</script>
